"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _templateObject;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputStyled = exports.modifiers = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_components_modifiers_1 = require("styled-components-modifiers");
var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");
exports.modifiers = {
  standard: function standard(_ref) {
    var theme = _ref.theme;
    return {
      styles: "\n      margin: unset;\n\n      div {\n        max-width: unset;\n\n        .MuiInputBase-input {\n          height: unset;\n          color: ".concat(theme.farmProject.white, ";\n          background-color: transparent;\n          label {\n            z-index: 1;\n            pointer-events: none;\n          }\n        }\n      }\n    ")
    };
  },
  brandForStandard: function brandForStandard(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: "\n      .MuiInput-underline:before {\n        border-bottom-color: ".concat(theme.farmProject.light_gray, ";\n      }\n\n      .MuiInput-underline:hover:not(.Mui-disabled):before {\n        border-bottom-width: 1px;\n        border-bottom-color: ").concat(theme.farmProject.brand_primary, ";\n      }\n\n      .MuiInput-underline:after {\n        border-bottom-color: ").concat(theme.farmProject.brand_primary, ";\n      }\n\n      div {\n        label {\n          transform: translate(0, 24px) scale(1);\n          color: ").concat(theme.farmProject.brand_primary, ";\n          &.Mui-focused {\n            color: ").concat(theme.farmProject.brand_primary, ";\n          }\n        }\n      }\n    ")
    };
  },
  brandForStandardBlackBackground: function brandForStandardBlackBackground(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: "\n      .MuiInput-underline:before {\n        border-bottom-color: ".concat(theme.farmProject.light_gray, ";\n      }\n\n      .MuiInput-underline:hover:not(.Mui-disabled):before {\n        border-bottom-width: 1px;\n        border-bottom-color: ").concat(theme.farmProject.gray_3, ";\n      }\n\n      .MuiInput-underline:after {\n        border-bottom-color: ").concat(theme.farmProject.gray_3, ";\n      }\n\n      div {\n        label {\n          transform: translate(0, 24px) scale(1);\n          color: ").concat(theme.farmProject.gray_3, ";\n          &.Mui-focused {\n            color: ").concat(theme.farmProject.gray_3, ";\n          }\n        }\n      }\n    ")
    };
  },
  clear: function clear() {
    return {
      styles: "\n    div {\n      .MuiInputBase-input {\n        background: transparent;\n        height: 2.5rem;\n\n      }\n    }\n    "
    };
  },
  fluid: function fluid() {
    return {
      styles: "\n        margin: unset;\n        div {\n          max-width: unset;\n        }\n    "
    };
  },
  smallMargin: function smallMargin() {
    return {
      styles: "\n      margin-bottom: 0;\n      margin-top: 1rem;\n\n      @media ".concat(atoms_utils_theme_1.breakPoints.medium_break, " {\n        margin-bottom: 0.5rem;\n      }\n    ")
    };
  }
};
exports.InputStyled = styled_components_1.default.div.attrs({
  className: 'InputStyled'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  margin: 2rem auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  div {\n    width: 100%;\n    max-width: 18rem;\n    display: block;\n\n    ", ";\n\n    .MuiInputBase-input {\n      font-size: 0.875rem;\n      font-family: ", ";\n      line-height: 1rem;\n      box-sizing: border-box;\n      height: 3.5rem;\n      color: ", ";\n      background-color: ", ";\n    }\n\n    ::placeholder {\n      color: ", ";\n    }\n\n    .MuiFilledInput-root:hover {\n      background-color: ", ";\n    }\n\n    label {\n      font-family: ", ";\n      font-size: 0.75rem;\n      text-transform: unset;\n      color: ", ";\n      transform: translate(0.75rem, 1.45rem) scale(1);\n      pointer-events: none;\n      z-index: 1;\n\n      &.Mui-focused {\n        color: ", ";\n      }\n      &.MuiFormLabel-root.Mui-error {\n        color: ", ";\n      }\n    }\n  }\n\n  .MuiFilledInput-underline:before {\n    border-bottom-color: ", ";\n  }\n\n  .MuiFilledInput-underline:hover:not(.Mui-disabled):before {\n    border-bottom-color: ", ";\n  }\n\n  .MuiFilledInput-underline:after {\n    border-bottom-color: ", ";\n  }\n\n  .MuiFilledInput-underline.Mui-error:after {\n    border-bottom-color: ", ";\n  }\n\n  .MuiInput-underline:before {\n    border-bottom-color: ", ";\n  }\n\n  .MuiInput-underline:hover:not(.Mui-disabled):before {\n    border-bottom-color: ", ";\n  }\n\n  .MuiInput-underline:after {\n    border-bottom-color: ", ";\n  }\n\n  .MuiInput-underline.Mui-error:after {\n    border-bottom-color: ", ";\n  }\n\n  .MuiInputLabel-shrink {\n    transform: translate(0, 6px) scale(0.75);\n  }\n\n  .MuiInputAdornment-root .Icon {\n    position: absolute;\n    right: 5px;\n    top: 50%;\n    width: 1rem;\n    height: 1rem;\n    transform: translateY(-50%);\n  }\n\n  .MuiFilledInput-adornedEnd {\n    padding-right: 0;\n  }\n\n  @media ", " {\n    margin-bottom: 3.5rem;\n  }\n\n  ", ";\n"])), atoms_utils_theme_1.MuiFormHelperText, function (props) {
  return props.theme.farmProject.font_family;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.farmProject.dark_gray;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.farmProject.gray_2;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.farmProject.brand_primary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.farmProject.gray_3;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.farmProject.font_family;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.farmProject.dark_gray;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.farmProject.brand_primary;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.farmProject.red;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.farmProject.dark_gray;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.farmProject.brand_primary;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.farmProject.brand_primary;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.farmProject.red;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.farmProject.dark_gray;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.farmProject.brand_primary;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.farmProject.brand_primary;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.farmProject.red;
}, atoms_utils_theme_1.breakPoints.medium_break, (0, styled_components_modifiers_1.applyStyleModifiers)(exports.modifiers));